module.exports = __webpack_public_path__ + "static/booklet-4b307fd870b02e96b7471c8f4e449c03.jpg";